import { Box } from '@mui/material';
import styles from './customToaster.module.scss';
import { ReactComponent as IconCancel } from 'assets/icons/icon_alertCancel.svg';

const CustomToaster = ({ onClose, text = 1 }: { onClose: () => void; text: number }) => {
  return (
    <Box className={styles.modalToaster}>
      <p>
        {text === 1 ? 'Пожалуйста, заполните пустые поля!' : 'Эта информация уже существует!'}
      </p>
      <button type='button' onClick={onClose}>
        <IconCancel />
      </button>
    </Box>
  );
};

export default CustomToaster;
